var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.unitPopupContentComponent,{tag:"component",attrs:{"unit":_vm.unit}})
}
var staticRenderFns = []

export { render, staticRenderFns }